import CTAButton from '@/components/shared/CTAButton'

const VehicleFactsSection = ({ vehicleMake, article }) => {
  return (
    <section
      className="py-12 md:py-16"
      style={{ backgroundColor: 'rgba(25, 135, 84, 0.1)' }}
    >
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-6 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          <strong>
            Facts About UK Car Finance Mis-Selling of {vehicleMake} Cars
          </strong>
        </h2>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Millions of drivers across the UK may be entitled to compensation due
          to mis-sold car finance agreements, and many of those affected
          financed {vehicleMake} vehicles. According to the Financial Conduct
          Authority (FCA), around 95% of car finance deals included commission
          payments between lenders and dealerships, often without the
          customer&apos;s knowledge. Shockingly, up to 44%
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>4</sup> of
          these agreements may have been mis-sold, meaning many {vehicleMake}{' '}
          customers unknowingly paid more than they should have.
        </p>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          If you purchased {article} {vehicleMake} using car finance after 2007,
          including Personal Contract Purchase (PCP), Hire Purchase (HP), lease
          purchase agreements or a personal loan arranged through
          {article} {vehicleMake} dealership, you may be eligible to make a
          claim. This applies whether the vehicle was new or used, and includes
          cars, vans and other vehicle types.
        </p>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Compensation can vary based on your specific agreement. While some
          reports suggest potential payouts in the thousands, the FCA has stated
          that, on average, drivers could receive around £
          <span className="font-raleway-numbers">829</span>
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>2</sup> per
          claim. A recent Supreme Court ruling and an FCA investigation have
          confirmed this is a widespread issue, paving the way for mass claims
          across the country.
        </p>

        <p
          className="mb-8 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          If you suspect your {vehicleMake} finance deal was mis-sold, now is
          the time to act. With millions of potential claims and funds already
          set aside, checking your eligibility could be the first step toward
          reclaiming the money you&apos;re owed.
        </p>

        <div className="text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default VehicleFactsSection
